import React from "react";
import { Quote, Star } from "lucide-react";
import { testimonials } from "../../mock";

const Testimonials = () => {
  return (
    <section className="py-20 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-5 lg:px-6">
        <div className="max-w-2xl mb-12">
          <div className="text-[12px] uppercase tracking-[0.22em] font-semibold text-teal-700">Client Voices</div>
          <h2 className="mt-3 font-display font-extrabold text-slate-900 text-[34px] lg:text-[46px] leading-[1.08]">
            Decade-long partnerships, <span className="text-gradient-brand">in their words</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <figure key={i} className="card-lift bg-white rounded-2xl border border-slate-200 p-6 flex flex-col">
              <Quote className="h-7 w-7 text-teal-700/30" />
              <div className="flex gap-0.5 mt-3">
                {[...Array(5)].map((_, k) => (<Star key={k} className="h-4 w-4 fill-amber-400 text-amber-400" />))}
              </div>
              <blockquote className="mt-4 text-slate-700 text-[14.5px] leading-relaxed flex-1">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-5 pt-4 border-t border-slate-100">
                <div className="font-display font-bold text-slate-900">{t.name}</div>
                <div className="text-[12.5px] text-slate-500">{t.role} · {t.company}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
